// extracted by mini-css-extract-plugin
export default {"header":"BomTable_header__8T1N0","body":"BomTable_body__sfCC-"};